export const circlePictogramNumber = {
  backgroundColor: "primary.main",
  borderRadius: "50%",
  color: "primary.contrastText",
  minWidth: "2.75rem",
  textAlign: "center",
};
